import React, { useEffect, useState } from 'react';
import LogoBCA from '../../assets/logo/bca.png';
import { ReactComponent as ChevDown } from '../../assets/icons/chevron-down-outline.svg';
import { ReactComponent as ChevUp } from '../../assets/icons/chevron-up-outline.svg';
import ButtonPrimary from '../misc/ButtonPrimary';
const ModalHowToTransfer = (props) => {
  const [showStep, setShowStep] = useState(null);
  const toggleStep = (stepIndex) => {
    if (showStep === stepIndex) setShowStep(null);
    else setShowStep(stepIndex);
  };
  // Overflow hidden
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => (document.body.style.overflow = 'unset');
  }, []);
  const defaultTransfer = [
    {
      hintOne: 'Petunjuk Transfer Via ATM BCA',
      stepByStep: [
        {
          id: '1',
          step: 'Pilih m-Transfer > BCA Virtual Account',
        },
        {
          id: '2',
          step:
            'Masukan nomor virtual account 64566 08123456789 dan pilih Send0',
        },
        {
          id: '3',
          step:
            'Masukan jumlah top up ShopeePay yang diinginkan Min. Top Up Rp10.000',
        },
        {
          id: '4',
          step: 'Periksa informasi yang tertera di layar. Jika benar, pilih OK',
        },
        {
          id: '5',
          step: 'Masukan PIN m-BCA Anda dan pilih OK',
        },
      ],
    },
    {
      hintOne: 'Petunjuk Transfer Via klik BCA',
      stepByStep: [
        {
          id: '1',
          step: 'Pilih m-Transfer > BCA Virtual Account',
        },
        {
          id: '2',
          step:
            'Masukan nomor virtual account 64566 08123456789 dan pilih Send0',
        },
        {
          id: '3',
          step:
            'Masukan jumlah top up ShopeePay yang diinginkan Min. Top Up Rp10.000',
        },
        {
          id: '4',
          step: 'Periksa informasi yang tertera di layar. Jika benar, pilih OK',
        },
        {
          id: '5',
          step: 'Masukan PIN m-BCA Anda dan pilih OK',
        },
      ],
    },
    {
      hintOne: 'Petunjuk Transfer Via m-BCA',
      stepByStep: [
        {
          id: '1',
          step: 'Pilih m-Transfer > BCA Virtual Account',
        },
        {
          id: '2',
          step:
            'Masukan nomor virtual account 64566 08123456789 dan pilih Send0',
        },
        {
          id: '3',
          step:
            'Masukan jumlah top up ShopeePay yang diinginkan Min. Top Up Rp10.000',
        },
        {
          id: '4',
          step: 'Periksa informasi yang tertera di layar. Jika benar, pilih OK',
        },
        {
          id: '5',
          step: 'Masukan PIN m-BCA Anda dan pilih OK',
        },
      ],
    },
  ];
  return (
    <div className="modal fixed w-full min-h-screen top-0 left-0 flex items-center justify-center z-20 overflow-hidden">
      <div className="modal-overlay absolute w-full h-full bg-gray-900 opacity-50 overflow-hidden"></div>
      <div className="modal-container bg-white w-11/12 md:max-w-lg mx-auto rounded shadow-lg z-50 overflow-y-auto">
        <div className="modal-content items-center py-6 px-8 text-left">
          <div className="flex mb-4 relative justify-center">
            <h4>Cara Transfer</h4>
            <button
              className="px-2 ml-auto absolute top-0 right-0"
              onClick={props.handdleCloseModal}
            >
              X
            </button>
          </div>
          <div className="flex flex-col  my-4 w-full px-4">
            <div className="flex items-center ">
              <img src={LogoBCA} className="h-4 mr-4" alt="Logo BCA" />
              <p>Bank BCA (Dicek Otomatis)</p>
            </div>
            <div className="flex flex-col w-full mt-3">
              <p className="text-sm opacity-50">No. Virtual Account</p>
              <div className="flex justify-between">
                <p className="font-semibold">64566 08123456789</p>
                <button className="text-basic-orange px-2 py-1">Salin</button>
              </div>
              <p className="text-sm text-basic-orange my-2">
                Dicek dalam 10 menit setelah pembayaran berhasil
              </p>
              <p className="text-sm">Hanya menerima dari Bank BCA</p>
            </div>
            {/* Content Step */}
            <div className="flex flex-col w-full mb-2 mt-6 max-h-70 overflow-y-scroll">
              {defaultTransfer.map((defaultTransfers, index) => (
                <>
                  <button
                    className="border-t border-b border-gray-200 py-2 px-4 flex items-center"
                    key={index}
                    onClick={() => {
                      toggleStep(index);
                    }}
                  >
                    <p>{defaultTransfers.hintOne}</p>
                    {showStep === index ? (
                      <ChevUp className="h-4 w-4 ml-auto" />
                    ) : (
                      <ChevDown className="h-4 w-4 ml-auto" />
                    )}
                  </button>
                  {/* List Step */}
                  <ul className="list-outside list-decimal text-sm px-8 py-2">
                    {showStep === index &&
                      defaultTransfers.stepByStep.map((stepBySteps, index) => (
                        <>
                          <li key={index}>{stepBySteps.step}</li>
                        </>
                      ))}
                  </ul>
                  {/* End List Step */}
                </>
              ))}
            </div>
            {/* End Content Step */}
          </div>
          <ButtonPrimary
            handdleClick={props.handdleClickConfirm}
            text="sm"
            addClass={'w-full'}
          >
            Konfirmasi
          </ButtonPrimary>
        </div>
      </div>
    </div>
  );
};

export default ModalHowToTransfer;
